<template>
  <div class="container-fluid" v-if="model.statusId">
    <page-header
      :actions="headerActionsConfig"
      :page="headerConfig"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    />

    <InformationHeader
      ref="InformationHeader"
      :request-id="requestId"
      :assistant-type-id="model.assistantTypeId"
      :status-id="model.statusId"
    >
    <board
      v-if="!isRequestForOneStudent"
      slot="sub-board"
      class="custom-board-prov-remedy"
      :details="studentBoardDetails"
      row-class="py-0"
    />
    </InformationHeader>

    <validation-observer
      ref="provisionalRemedyRequestRef"
      v-slot="{}"
      tag="form"
    >
        <AssistantService 
          :is-read-only="isReadOnly" 
          :isTransportationNecesitySelected="model.isTransportationNecesitySelected" 
          @update-service="service = $event" 
        />

        <RequestGeneralInfo
          v-model="model.generalInformation"
          :applicant-categories="applicantCategories"
          :is-read-only="isReadOnly"
          :isTransportationNecesitySelected="model.isTransportationNecesitySelected" 
          :userFullName="model.userFullName"
        />

       <RequestContactInfo
          v-model="model.contactInformation"
          :is-read-only="isReadOnly"
        />

        <RequestPostalAddressInfo
          v-model="model.postalAddress"
          :is-read-only="isReadOnly"
          :municipalities="municipalities"
        />

        <RequestEducationalServiceInfo
          v-model="model.studentInformation.location"
          :academic-year-id="model.academicYearId"
          :default-value="model.studentInformation.location"
          :is-read-only="isReadOnly"
          :location-types="locationTypes"
        />

        <RequestAdditionalInfo
          v-model="model.generalInformation.additionalComments"
          :is-read-only="isReadOnly"
        />
    </validation-observer>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import Board from 'Board';
import CustomError from 'custom-error';
import { CustomTab, CustomTabItem } from 'custom-tabs';
import { ValidationObserver } from 'vee-validate';
import {
  getProvRemRequestData,
  submitProvRemRequest,
} from "@/modules/peiSAEE/api.js";
import { requestTypeCodes } from "@/utils/constants/hrrequest/requestTypeCodes";
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import RequestStatuses from '@/utils/constants/requestServiceStatuses';
import loadingMixin from '@quisit/mipe-utils/mixins/loading';
import {
  RequestGeneralInfo,
  RequestContactInfo,
  RequestPostalAddressInfo,
  RequestEducationalServiceInfo,
  RequestAdditionalInfo,
  AssistantService,
} from './components/prov-rem-request';
import InformationHeader from "./components/InformationHeader";

export default {
  components: {
    PageHeader,
    InformationHeader,
    CustomTab,
    CustomTabItem,
    Board,
    CustomError,
    ValidationObserver,
    RequestGeneralInfo,
    RequestContactInfo,
    RequestPostalAddressInfo,
    RequestEducationalServiceInfo,
    RequestAdditionalInfo,
    AssistantService
  },
  mixins: [alertMixin, loadingMixin],
  data: () => ({
    applicantCategories: [],
    municipalities: [],
    locationTypes: [],
    unAvailableServices: [],
    requestServices: [],
    model: {
      generalInformation: {
        requestDate: null,
        applicantName: null,
        unknownApplicantNameFlag: false,
        personInChargeName: null,
        applicantPositionId: null,
      },
      contactInformation: {
        contactName: null,
        email: null,
        cellPhone: null,
        homePhone: null,
        workPhone: null,
        extension: null,
      },
      postalAddress: {
        addressLine1: null,
        addressLine2: null,
        municipalityId: null,
        state: null,
        postalCode: null,
      },
      studentInformation: {
        studentName: null,
        regStudent: null,
        impedimentDescription: null,
        impedimentId: null,
        location: {
          locationType: { name: '' },
          region: { name: '' },
          district: { name: '' },
          municipality: { name: '' },
          school: { name: '' },
          name: null,
        },
      },
      request: {},
    },
    service: {}
  }),
  computed: {
    headerConfig() {
      return {
        icon: 'fas fa-clipboard-list',
        title: 'Solicitud de Remedio Provisional',
        routes: [
          'Inicio',
          'Estudiante',
          'Solicitud de Remedio Provisional',
        ],
      };
    },
    headerActionsConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left fa-fw',
          variant: 'outline-success',
          click: () => this.$router.push({ path: `/humanres/irregularrequest/edit/${this.requestId}`}),
        },
        {
          text: 'Guardar',
          icon: 'fas fa-save pr-2',
          variant: 'success',
          visible: !this.isReadOnly,
          click: () => this.onSubmitHandler(),
        },
      ];
    },
    studentBoardDetails() {
      return [
        [
          {
            label: 'Estudiante:',
            data: this.model.studentInformation?.studentName,
            icon: 'fas fa-address-book',
            cols: 'col-12 col-lg-4 w-50',
          },
          {
            label: 'Número de Registro:',
            data: this.model.studentInformation?.regStudent,
            icon: 'fas fa-address-book',
            cols: 'col-12 col-lg-4 w-50',
          },
          {
            label: 'Impedimento:',
            data: this.model.studentInformation?.impedimentDescription,
            icon: 'fas fa-ballot-check',
            cols: 'col-12 col-lg-4 w-50',
          },
        ],
      ];
    },
    isRequestStatusNew() {
      if (this.model.generalInformation?.requestStatusId === 0) return true;
      return (
        this.model.generalInformation?.requestStatusId === RequestStatuses.New
      );
    },
    isRequestForOneStudent() {
      return this.model.assistantTypeId == requestTypeCodes.Estudiantes;
    },
    requestId() {
      return Number(this.$route.params.requestId) || null;
    },
    isReadOnly() {
      return false;
    },
    requestServiceRef() {
      return this.$refs.requestServiceRef;
    },
    getServiceModel() {
      return (service, idx, getCatalogOption = false) => {
        return {
          [`requestService${service.component}`]: this.requestServiceComponentRef(
            service.component,
            idx
          )?.getModel(getCatalogOption),
        };
      };
    },
  },
  async beforeRouteUpdate(to, from, next) {
    if (to.path !== from.path) {
      next();
      await this.onLoad(to.params.studentSieId, to.params.requestId);
    }
  },
  created() {
    this.ShowWait();
  },
  async mounted() {
    await this.onLoad();
  },
  methods: {
    async onLoad(studentSieId = null, requestId = null) {
      await Promise.all([
        this.getGeneralInformation(
          studentSieId ?? this.$route.params?.studentSieId,
          requestId ?? this.$route.params?.requestId
        ),
      ]);
    },
    async getGeneralInformation(studentSieId, requestId) {
      const { data } = await getProvRemRequestData({studentSieId, requestId});
      this.setCollections(data.collections);
      this.requestServices = data.requestServices;
      this.model = {
        ...data.requestInformation,
        postalAddress: {
          ...data.requestInformation?.postalAddress,
          state: data.requestInformation?.postalAddress?.state || 'PR',
        },
        ...data.request,
      };
      this.HideWait();
    },
    async onSubmitHandler() {
      const isFormValid = await this.$refs.provisionalRemedyRequestRef.validate();

      if (!isFormValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }

      const {
        studentInformation,
        generalInformation,
        contactInformation,
        postalAddress,
      } = this.model;

      var payload = {
        //general info
        studentSieId: studentInformation.studentSieId,
        requestDate: generalInformation.requestDate,
        applicantName: generalInformation.applicantName,
        unknownApplicantNameFlag:
          generalInformation.unknownApplicantNameFlag || false,
        applicantPositionId: generalInformation.applicantPositionId,
        personInChargeName: contactInformation.personInChargeName,

        //contact info
        applicantEmail: contactInformation.email,
        contactCellPhoneNumber: contactInformation.cellPhone,
        contactResidentialPhoneNumber: contactInformation.homePhone,
        contactWorkPhoneNumber: contactInformation.workPhone,
        contactWorkPhoneExtension: contactInformation.extension,

        //address
        postalAddressLine1: postalAddress.addressLine1,
        postalAddressLine2: postalAddress.addressLine2,
        postalAddressZipCode: postalAddress.postalCode,
        postalAddressCityId: postalAddress.municipalityId,
        city: postalAddress.state,

        //documents
        documents: [],

        //educational service info
        locationTypeId: studentInformation.location.locationType?.id,
        municipalityId: studentInformation.location.municipality?.id,
        regionId: studentInformation.location.region?.id,
        districtId: studentInformation.location.district?.id,
        locationSchoolId: studentInformation.location.school?.id,
        centerId: studentInformation.location.center?.id,
        privateLocationName: studentInformation.location.privateLocationName,

        //additional info
        additionalInformation: generalInformation.additionalComments,

        //services
        services: [this.service],
      };

      const { data: result } = await submitProvRemRequest(this.requestId, payload).catch((err) => {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      });

      if (result?.requestId) {
        this.ShowToast(
          'Proceso Exitoso',
          'La solicitud ha sido sometida exitosamente.',
          'success'
        );
        this.$router.replace({
          name: 'EditIrregularRequestPersonalStaff',
          params: {
            id: this.requestId,
            tab: this.isRequestForOneStudent ? undefined : 1
          },
        });
      }
    },
    requestServiceComponentRef(componentName, idx) {
      let component = this.requestServiceRef.$refs[`${componentName}-${idx}`];
      return component != undefined ? component[0] : null;
    },
    setCollections(collections) {
      this.applicantCategories = [...collections.applicants].sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      this.municipalities = collections.municipalities ?? [];
      this.locationTypes = collections.locationTypes ?? [];
      this.unAvailableServices = collections.servicesNotAvailables ?? [];
    },
  },
};
</script>

<style lang="scss">
.custom-tab-prov-remedy .custom-tab-container .nav-item .nav-link.active {
  border-bottom: 3px solid #ff7058 !important;
  color: #ff7058 !important;
}
.custom-board-prov-remedy, .custom-board-prov-remedy > div > div.bg-white {
  background-color: transparent !important;
}
.title-bread-crumb-prov-remedy mb-3 > div > div.tag-badge {
  background: none !important;
}
.request-general-info-main-section .custom-disabled-label > div.input-display {
  margin-left: auto !important;
}

@media screen and (max-width: 768px) {
  div.actions button {
    width: 90% !important;
    padding: 10px !important;
  }
  div.actions {
    padding-right: 0 !important;
  }
  div.actions div {
    width: 100% !important;
  }
  div.actions.mobile-actions.col-xl-4 {
    display: flex;
    width: 100%;
  }

  label {
    margin-top: 1rem !important;
  }

  div.bg-light.rounded.p-4 {
    padding: 10px 0px 10px 0px !important;
  }

  button.btn.bg-light-white.w-75.pt-1 {
    width: 100% !important;
  }
}
</style>
